export const SYNCED_CONDITION_TYPES = [
  "If answer to question is",
  "If answer to question is NOT",
  "If survey selection matches",
  "If survey selection does NOT match",
  "If CTA survey selection matches",
  "If CTA survey selection does NOT match",
];

const conditionUpdate = (condition, setting_name, value, old_value) => ({
  object_type: "conditions",
  object_id: condition.id,
  setting_name,
  value,
  old_value,
});

export const conditionKeywordUpdates = (
  variant,
  field,
  field_option,
  new_value,
  old_value
) => {
  const previous =
    old_value + "" === "" ? (field_option.label || "") + "" : old_value + "";

  return Object.values(variant.conditions || {})
    .filter((c) => {
      if (!SYNCED_CONDITION_TYPES.includes(c.condition_type) || !c.data) {
        return false;
      }
      if (c.data["field_option_id"] == field_option.id + "") return true;
      if (previous === "" || c.keyword != previous) return false;

      const linkedField = (variant.fields || {})[c.data["field_id"]];
      if (linkedField && linkedField.id != field.id) return false;

      const linkedOption = (variant.field_options || {})[
        c.data["field_option_id"]
      ];

      return (
        c.data["slug"] == field.slug &&
        (!linkedOption || linkedOption.value != c.keyword)
      );
    })
    .map((c) => conditionUpdate(c, "[keyword]", new_value, c.keyword));
};

export const conditionSlugUpdates = (variant, field, new_slug, old_slug) =>
  Object.values(variant.conditions || {})
    .filter((c) => {
      if (!c.data) return false;
      if (c.data["field_id"] == field.id + "") return true;
      if (!old_slug || c.data["slug"] != old_slug) return false;

      const linkedField = (variant.fields || {})[c.data["field_id"]];
      return !linkedField || linkedField.slug != c.data["slug"];
    })
    .map((c) => conditionUpdate(c, "[data][slug]", new_slug, c.data["slug"]));
